import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';
import { PhxIconButtonSize, PhxIconButtonType, PhxIconButtonDefaultValues, PhxIconButtonShape } from './phx-icon-button.types';
import { CircleLoading } from './../icon/icon-map';
import mixinDisabled from '../../mixins/disabled';
import { PHX_SIZE, PHX_ICON_SIZE } from '../../constants';

export const phxIconButtonDefaultValues: PhxIconButtonDefaultValues = {
  size: PHX_SIZE.MD,
  type: 'default',
  shape: 'default',
};

const baseButtonMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

@Component({
  selector: 'button[phx-icon-button]',
  templateUrl: './phx-icon-button.component.html',
  styleUrls: ['./phx-icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  inputs: ['disabled'],
  host: {
    class: 'phx-icon-button',
    '[class.phx-icon-button-xxxs]': `phxIconButtonSize === PHX_BUTTON_SIZE.XXXS`,
    '[class.phx-icon-button-xxs]': `phxIconButtonSize === PHX_BUTTON_SIZE.XXS`,
    '[class.phx-icon-button-xs]': `phxIconButtonSize === PHX_BUTTON_SIZE.XS`,
    '[class.phx-icon-button-sm]': `phxIconButtonSize === PHX_BUTTON_SIZE.SM`,
    '[class.phx-icon-button-md]': `phxIconButtonSize === PHX_BUTTON_SIZE.MD`,
    '[class.phx-icon-button-lg]': `phxIconButtonSize === PHX_BUTTON_SIZE.LG`,
    '[class.phx-icon-button-xl]': `phxIconButtonSize === PHX_BUTTON_SIZE.XL`,
    '[class.phx-icon-button-xxl]': `phxIconButtonSize === PHX_BUTTON_SIZE.XXL`,
    '[class.phx-icon-button-accent]': `phxIconButtonType === 'accent'`,
    '[class.phx-icon-button-negative]': `phxIconButtonType === 'negative'`,
    '[class.phx-icon-button-positive]': `phxIconButtonType === 'positive'`,
    '[class.phx-icon-button-on-medium]': `phxIconButtonType === 'on-medium'`,
    '[class.phx-icon-button-on-bold]': `phxIconButtonType === 'on-bold'`,
    '[class.phx-icon-button-on-overlay]': `phxIconButtonType === 'on-overlay'`,
    '[class.phx-icon-button-rounded]': `phxIconButtonShape === 'rounded'`,
    '[attr.disabled]': 'disabled || phxLoading ? true : null',
  },
})
export class PhxIconButtonComponent extends baseButtonMixin {
  @Input() phxIcon: string;
  @Input() phxIconButtonSize: PhxIconButtonSize = phxIconButtonDefaultValues.size;
  @Input() phxIconButtonType: PhxIconButtonType = phxIconButtonDefaultValues.type;
  @Input() phxIconButtonShape: PhxIconButtonShape = phxIconButtonDefaultValues.shape;
  @Input() phxLoading: boolean = false;

  public readonly CircleLoadingIcon: string = CircleLoading;
  public readonly PHX_BUTTON_SIZE = { ...PHX_SIZE, XXXS: 'extra-extra-extra-small' };

  public get iconSize(): number {
    const { phxIconButtonSize, PHX_BUTTON_SIZE } = this;

    if (phxIconButtonSize === PHX_BUTTON_SIZE.XXXS || phxIconButtonSize === PHX_BUTTON_SIZE.XXS || phxIconButtonSize === PHX_BUTTON_SIZE.XS) return PHX_ICON_SIZE.SM;
    if (phxIconButtonSize === PHX_BUTTON_SIZE.SM || phxIconButtonSize === PHX_BUTTON_SIZE.MD || phxIconButtonSize === PHX_BUTTON_SIZE.LG) return PHX_ICON_SIZE.MD;
    if (phxIconButtonSize === PHX_BUTTON_SIZE.XXL || phxIconButtonSize === PHX_BUTTON_SIZE.XL) return PHX_ICON_SIZE.LG;
    return PHX_ICON_SIZE.MD;
  }
}
